import request from "@/utils/request";

export function getJstConfig() {
  return request({
    url: "/erp/jst/config",
    method: "get"
  });
}

export function refreshJstToken() {
  return request({
    url: "/erp/jst/token/refresh",
    method: "post"
  });
}

export function getJstRecordSummary() {
  return request({
    url: "/erp/jst/record/summary",
    method: "get"
  });
}

export function getJstRecordList(params) {
  return request({
    url: "/erp/jst/record/list",
    method: "get",
    params
  });
}

export function retryJstRecord(recordId) {
  return request({
    url: "/erp/jst/record/retry",
    method: "post",
    params: { recordId }
  });
}

export function syncJstOrder(orderId) {
  return request({
    url: "/erp/jst/order/sync",
    method: "post",
    params: { orderId }
  });
}

export function syncPendingJstOrders(limit) {
  return request({
    url: "/erp/jst/order/syncPending",
    method: "post",
    params: { limit }
  });
}

export function syncJstDelivery(orderId) {
  return request({
    url: "/erp/jst/order/delivery/sync",
    method: "post",
    params: { orderId }
  });
}

export function syncPendingJstDelivery(limit) {
  return request({
    url: "/erp/jst/order/delivery/syncPending",
    method: "post",
    params: { limit }
  });
}

export function reconcileJstOrders(limit) {
  return request({
    url: "/erp/jst/order/reconcile",
    method: "post",
    params: { limit }
  });
}

export function syncJstAfterSale(afterId) {
  return request({
    url: "/erp/jst/aftersale/sync",
    method: "post",
    params: { afterId }
  });
}

export function reconcileJstAfterSales(limit) {
  return request({
    url: "/erp/jst/aftersale/reconcile",
    method: "post",
    params: { limit }
  });
}

export function syncJstGoods(goodsId) {
  return request({
    url: "/erp/jst/goods/sync",
    method: "post",
    params: { goodsId }
  });
}

export function importJstGoods(data) {
  return request({
    url: "/erp/jst/goods/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}
